/**
 * Calculateur de taille AFTR : moteur de calcul (aucun accès au DOM).
 * Le même fichier tourne dans le navigateur (window.AftrSizeEngine) et sous Node (tests).
 * La table est lue en tailles FRANÇAISES ; chaque système de tailles affiche les mêmes
 * positions avec ses propres libellés, donc la conversion est une simple position dans la liste.
 * Version de table : à incrémenter à chaque changement de cellule (elle part dans la mémoire et la mesure).
 */
(function (root) {
  'use strict';

  var TABLE_VERSION = 2; // table du calculateur d'origine, conversions par pays corrigées
  var SIZES = ['S', 'M', 'L', 'XL'];

  // Position i d'un tour = tour français 80 + 5i ; position i d'un bas (ou d'un haut) = taille française 34 + 2i.
  // Position i d'un bonnet = bonnet français A (0) à G (6). La première et la dernière pastille absorbent les extrêmes.
  var SYSTEMS = {
    FR: { bands: ['80', '85', '90', '95', '100', '105', '110'], cups: ['A', 'B', 'C', 'D', 'E', 'F', 'G'], clothes: ['34', '36', '38', '40', '42', '44', '46', '48', '50'], example: '90B' },
    EU: { bands: ['65', '70', '75', '80', '85', '90', '95'], cups: ['A', 'B', 'C', 'D', 'E', 'F', 'G'], clothes: ['32', '34', '36', '38', '40', '42', '44', '46', '48'], example: '75B' },
    IT: { bands: ['1', '2', '3', '4', '5', '6', '7'], cups: ['A', 'B', 'C', 'D', 'E', 'F', 'G'], clothes: ['38', '40', '42', '44', '46', '48', '50', '52', '54'], example: '3B' },
    UK: { bands: ['30', '32', '34', '36', '38', '40', '42'], cups: ['A', 'B', 'C', 'D', 'DD', 'E', 'F'], clothes: ['6', '8', '10', '12', '14', '16', '18', '20', '22'], example: '34B' },
    US: { bands: ['30', '32', '34', '36', '38', '40', '42'], cups: ['A', 'B', 'C', 'D', 'DD', 'DDD', 'G'], clothes: ['2', '4', '6', '8', '10', '12', '14', '16', '18'], example: '34B' },
    AU: { bands: ['8', '10', '12', '14', '16', '18', '20'], cups: ['A', 'B', 'C', 'D', 'DD', 'E', 'F'], clothes: ['6', '8', '10', '12', '14', '16', '18', '20', '22'], example: '12B' }
  };

  // Bonnets saisis hors pastilles (anciens liens, tests, saisie libre) : en dessous de A = A, au-dessus de la liste = dernier.
  var SMALL_CUPS = { AA: 1, AAA: 1 };

  var COUNTRY_SYSTEM = {
    FR: 'FR', BE: 'FR', LU: 'FR', MC: 'FR', ES: 'FR', PT: 'FR',
    DE: 'EU', AT: 'EU', NL: 'EU', CH: 'EU', DK: 'EU', SE: 'EU', NO: 'EU', FI: 'EU', PL: 'EU', CZ: 'EU',
    IT: 'IT', GB: 'UK', IE: 'UK', US: 'US', CA: 'US', AU: 'AU', NZ: 'AU'
  };
  var LANG_SYSTEM = { fr: 'FR', de: 'EU', nl: 'EU', da: 'EU', sv: 'EU', pl: 'EU', it: 'IT', en: 'US' };

  // ---- Table du haut : [position du tour 0..5][position du bonnet 0..6]. Tour 110 et plus : aucune taille.
  // s : taille ferme. f : frontière [dessous, dessus] et son défaut (lo, hi, ou « bottom » = selon la taille de bas).
  // lvl « closest » : taille la plus proche, montrée sans être conseillée ni cochée d'office. « none » : aucune taille.
  function s(size, note) { return { s: size, note: note || null }; }
  function f(lo, hi, def, cupA) { return { f: [lo, hi], def: def, cupA: !!cupA }; }
  function c(size, note) { return { s: size, lvl: 'closest', note: note }; }
  var NONE = { lvl: 'none' };

  // TABLE DU CALCULATEUR D'ORIGINE (affinée à la main par Mathis), reprise telle quelle, lue en tailles françaises :
  //   bonnets A à C : tour jusqu'à 90 = S (90C = M), 95 à 105 = M, 110 et plus = L
  //   bonnet D      : tour jusqu'à 85 = M, 90 à 105 = L, 110 et plus = XL
  //   bonnet E      : tour jusqu'à 85 = M, 90 et 95 = L, 100 et plus = XL
  //   bonnets F et plus : tour jusqu'à 85 = L, 90 et plus = XL
  // Seules corrections (bogues) : AA était lu comme un C (90AA donnait M) ; les bonnets I et plus aussi (85I donnait S).
  var TOP = [
    /* 80   */ [s('S'), s('S'), s('S'), s('M'), s('M'), s('L'), s('L')],
    /* 85   */ [s('S'), s('S'), s('S'), s('M'), s('M'), s('L'), s('L')],
    /* 90   */ [s('S'), s('S'), s('M'), s('L'), s('L'), s('XL'), s('XL')],
    /* 95   */ [s('M'), s('M'), s('M'), s('L'), s('L'), s('XL'), s('XL')],
    /* 100  */ [s('M'), s('M'), s('M'), s('L'), s('XL'), s('XL'), s('XL')],
    /* 105  */ [s('M'), s('M'), s('M'), s('L'), s('XL'), s('XL'), s('XL')],
    /* 110+ */ [s('L'), s('L'), s('L'), s('XL'), s('XL'), s('XL'), s('XL')]
  ];

  // ---- Sans taille de soutien-gorge : taille de haut française (36 à 46) × poitrine (small, medium, large).
  var BUST = ['small', 'medium', 'large'];
  var TOP_APPROX = {
    36: [s('S'), s('S'), s('M')],
    38: [s('S'), s('S'), s('M')],
    40: [s('S'), s('M'), s('L')],
    42: [s('M'), s('M'), s('L')],
    44: [s('M'), s('L'), s('XL')],
    46: [s('M'), s('L'), s('XL')]
  };

  // ---- Bas : position 0..8 (français 34 à 50 et plus).
  var BOTTOM = [s('S'), s('S'), s('M'), s('M'), s('L'), s('L'), s('XL'), s('XL'), s('XL')];

  function rank(size) { return SIZES.indexOf(size); }
  function maxRank(product, axis) {
    // sizes : tailles du modèle ; bottomSizes (facultatif) : tailles du bas quand elles diffèrent de celles du haut
    var sizes = (product && ((axis === 'bottom' && product.bottomSizes) || product.sizes)) || SIZES, m = -1;
    for (var i = 0; i < sizes.length; i++) m = Math.max(m, rank(String(sizes[i]).toUpperCase()));
    return m < 0 ? SIZES.length - 1 : m;
  }

  function cupIndex(system, cup) {
    var list = SYSTEMS[system].cups, v = String(cup || '').toUpperCase().replace(/\s|\+/g, '');
    if (SMALL_CUPS[v]) return 0;
    var i = list.indexOf(v);
    if (i >= 0) return i;
    return /^[A-Z]{1,3}$/.test(v) ? list.length - 1 : -1; // lettre au-delà de la liste : dernière pastille
  }
  function listIndex(list, value, lowIsFirst) {
    var v = String(value == null ? '' : value).replace(/\s|\+/g, ''), i = list.indexOf(v);
    if (i >= 0) return i;
    var n = parseFloat(v);
    if (isNaN(n)) return -1;
    if (n < parseFloat(list[0])) return lowIsFirst ? 0 : -1;
    if (n > parseFloat(list[list.length - 1])) return list.length - 1;
    return -1;
  }

  /** Lecture des réponses en positions françaises. Retourne null si une réponse est illisible. */
  function read(answers) {
    var sys = SYSTEMS[answers && answers.system];
    if (!sys) return null;
    var bottom = listIndex(sys.clothes, answers.bottom, true);
    if (bottom < 0) return null;
    var out = { system: answers.system, mode: answers.mode === 'approx' ? 'approx' : 'bra', bottom: bottom, bottomFr: 34 + 2 * bottom };
    if (out.mode === 'approx') {
      var t = listIndex(sys.clothes, answers.topSize, true), b = BUST.indexOf(answers.bust);
      if (t < 0 || b < 0) return null;
      out.topFr = Math.max(36, 34 + 2 * t); out.bust = b;
    } else {
      var band = listIndex(sys.bands, answers.band, true), cup = cupIndex(answers.system, answers.cup);
      if (band < 0 || cup < 0) return null;
      out.band = band; out.cup = cup; out.bandFr = 80 + 5 * band; out.cupFr = SYSTEMS.FR.cups[cup];
    }
    return out;
  }

  function topCell(r) {
    if (r.mode === 'approx') return TOP_APPROX[Math.min(46, r.topFr)][r.bust];
    return r.band >= TOP.length ? NONE : TOP[r.band][r.cup];
  }

  /** Taille de haut avant prise en compte du modèle : { size, level, notes, frontier }. */
  function resolveTop(cell, r, pref, runsSmall) {
    if (cell.lvl === 'none') return { size: null, level: 'none', notes: ['HORS_GRILLE_RIEN'], frontier: null };
    if (!cell.f) return { size: cell.s, level: cell.lvl || 'ok', notes: cell.note ? [cell.note] : [], frontier: null };
    var lo = cell.f[0], hi = cell.f[1];
    var def = cell.def === 'bottom' ? (r.bottom <= 1 ? lo : hi) : (cell.def === 'hi' ? hi : lo);
    var forced = !!runsSmall && !cell.cupA; // modèle qui taille petit : dessus d'office, sauf petits bonnets (ils bâillent)
    var chosen = forced ? hi : (pref === 'up' ? hi : pref === 'down' ? lo : def);
    return { size: chosen, level: 'ok', notes: [], frontier: { lo: lo, hi: hi, def: forced ? hi : def, chosen: chosen, forced: forced } };
  }

  function cap(axis, max, code) {
    if (axis.size && rank(axis.size) > max) {
      axis.wanted = axis.size; axis.size = SIZES[max]; axis.level = 'closest'; axis.notes.push(code); axis.frontier = null;
    }
    return axis;
  }

  function compute(r, pref, product, runsSmall) {
    var max = maxRank(product);
    var top = resolveTop(topCell(r), r, pref, runsSmall);
    var bc = BOTTOM[r.bottom];
    var bottom = { size: bc.s || null, level: bc.lvl || 'ok', notes: bc.note ? [bc.note] : [], frontier: null };

    if (!product || product.kind !== 'single') {
      return { kind: 'set', top: cap(top, max, 'MAX_MODELE'), bottom: cap(bottom, maxRank(product, 'bottom'), 'MAX_MODELE_BAS'), single: null };
    }

    // Pièce à une seule taille (body).
    var single = { size: null, level: 'none', notes: top.notes.concat(bottom.notes), frontier: null };
    if (top.level !== 'none' && bottom.level !== 'none') {
      // Règle d'origine du calculateur pour une pièce à une seule taille :
      //  tailles égales → cette taille ; un cran d'écart → le haut si bonnet D ou plus, sinon le bas si bas 38 ou moins,
      //  sinon la plus grande (grand bonnet ET petit bas → la plus grande) ; deux crans ou plus → la taille du milieu.
      var t = rank(top.size), b = rank(bottom.size), bigCup = r.mode === 'approx' ? r.bust === 2 : r.cup >= 3, smallBottom = r.bottom <= 2, pick;
      if (t === b) pick = t;
      else if (Math.abs(t - b) === 1) pick = bigCup && smallBottom ? Math.max(t, b) : bigCup ? t : smallBottom ? b : Math.max(t, b);
      else pick = Math.round((t + b) / 2);
      single.size = SIZES[pick];
      single.level = 'ok';
      single.from = { top: top.size, bottom: bottom.size };
      cap(single, max, 'MAX_MODELE');
    }
    return { kind: 'single', top: null, bottom: null, single: single };
  }

  function signature(res) {
    return [res.top && res.top.size, res.bottom && res.bottom.size, res.single && res.single.size].join('|');
  }

  /**
   * answers : { system, mode: 'bra', band, cup, bottom } ou { system, mode: 'approx', topSize, bust, bottom }
   * pref    : 'up' | 'down' | null (choix fait sur une frontière)
   * product : { kind: 'set' | 'single', sizes: ['S','M','L','XL'], runsSmall: bool, bottomSizes?: [...], runsSmall: bool }
   * Retourne null si les réponses sont illisibles.
   */
  function recommend(answers, pref, product) {
    var r = read(answers);
    if (!r) return null;
    var runsSmall = !!(product && product.runsSmall);
    var res = compute(r, pref || null, product, runsSmall);
    res.read = r;
    res.estimate = r.mode === 'approx';
    res.tableVersion = TABLE_VERSION;
    // « Ce modèle taille petit » n'est dit que s'il change le conseil.
    res.runsSmallApplied = runsSmall && signature(res) !== signature(compute(r, pref || null, product, false));
    return res;
  }

  /** Les trois tailles « génériques » gardées en mémoire (modèle normal vendu jusqu'au XL). */
  function generic(answers, pref) {
    var set = recommend(answers, pref, { kind: 'set', sizes: SIZES });
    var one = recommend(answers, pref, { kind: 'single', sizes: SIZES });
    if (!set || !one) return null;
    return {
      topSize: set.top.level === 'ok' ? set.top.size : null,
      bottomSizeValue: set.bottom.level === 'ok' ? set.bottom.size : null,
      bodySize: one.single.level === 'ok' ? one.single.size : null
    };
  }

  function systemFor(country, lang) {
    return COUNTRY_SYSTEM[String(country || '').toUpperCase()] || LANG_SYSTEM[String(lang || '').slice(0, 2).toLowerCase()] || 'FR';
  }

  /** Même taille de soutien-gorge écrite dans un autre système (pour la ligne d'équivalence). */
  function braLabel(system, bandPos, cupPos) {
    var sys = SYSTEMS[system];
    return sys.bands[bandPos] + sys.cups[cupPos];
  }

  var api = {
    TABLE_VERSION: TABLE_VERSION,
    SIZES: SIZES,
    SYSTEMS: SYSTEMS,
    recommend: recommend,
    generic: generic,
    read: read,
    systemFor: systemFor,
    braLabel: braLabel
  };
  root.AftrSizeEngine = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
